import { IAnyObj } from "@dhx/ts-common/types";

const INDENT_STEP = 4;

export function jsonToXML(data: IAnyObj[], root = "root"): string {
	let result = `<?xml version="1.0" encoding="iso-8859-1"?>\n<${root}>`;
	for (let i=0; i<data.length; i++) {
		result += "\n" + itemToXML(data[i]);
	}
	return result + `\n</${root}>`;
}

function ws(count: number) {
	return " ".repeat(count);
}
function itemToXML(item: IAnyObj, indent: number = INDENT_STEP) {
	let result = ws(indent) + "<item>\n";
	for (const key in item) {
		if (Array.isArray(item[key])) {
			result += ws(indent + INDENT_STEP) + `<${key}>\n`;
			result += item[key].map((subItem: IAnyObj) => itemToXML(subItem, indent + INDENT_STEP * 2)).join("\n") + "\n";
			result += ws(indent + INDENT_STEP) + `</${key}>\n`;
		} else {
			result += ws(indent + INDENT_STEP) + `<${key}>${item[key]}</${key}>\n`;
		}
	}
	result += ws(indent) + "</item>";
	return result;
}
